import { Directive, Input, OnInit } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationTokenStorageService } from 'app/services';

@Directive({
  selector: '[appHasRole]',
})
export class HasRoleDirective implements OnInit {
  @Input('appHasRole')
  roles: string[] = [];

  constructor(
    private authenticationTokenStorageService: AuthenticationTokenStorageService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    console.log('roles size', this.roles.length);
    this.validate(this.roles);
    if (
      this.authenticationTokenStorageService.hasRootRole() ||
      this.authenticationTokenStorageService.hasAnyRole(this.roles)
    ) {
      // console.log('hasAnyRole', true);
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.viewContainer.clear();
  }

  private validate(roleNames: string[]) {
    if (!this.authenticationTokenStorageService.validateRoleNames(roleNames)) {
      throw new Error(
        ' Some given roles not recognized as valid role name, please use the AuthRole valid values:' +
          roleNames
      );
    }
  }
}
